/* eslint-disable consistent-return */
import { loadState, saveState } from '../../../utils/localStorage'

const localStorageMiddleware = store => next => (action) => {
    const persisted = action.meta && action.meta.persisted

    if (!persisted) {
        return next(action)
    }

    const previousState = store.getState()[persisted]
    next(action)
    const nextState = store.getState()[persisted]
    if (nextState !== previousState) {
        const localStorageState = loadState()
        saveState({
            ...localStorageState,
            [persisted]: nextState,
        })
    }
}

export default localStorageMiddleware
